import { Component, Injector, OnInit, OnDestroy } from '@angular/core';

import * as _ from 'lodash-es';
import moment from 'moment';

import { AppComponentBase } from '@shared/common/app-component-base';

import { AxillaPallet, AxillaPalletDimension, AxillaPackage } from '@app/shared/common/shop-system/models/models';

import { WebshopService } from '../services/webshop.service';


@Component({
    selector: 'app-pallets',
    templateUrl: './pallets.component.html',
    styleUrls: ['./pallets.component.less']
})
export class PalletsComponent extends AppComponentBase implements OnInit, OnDestroy {

    private _package: AxillaPackage;
    get package(): AxillaPackage {
        if (!this._package) {
            this._package = this._webshopService.package;
        }

        return this._package;
    }
    set package(value: AxillaPackage) {
        this._package = value;
    }

    get packagePallets() {
        return _.reverse(this.package.pallets);
    }

    packageUpdatetSubscription$;

    constructor(
        injector: Injector,
        private _webshopService: WebshopService
    ) {
        super(injector);
    }

    ngOnInit(): void {
        this._onPackageUpdate();

    }

    ngOnDestroy(): void {
        this.packageUpdatetSubscription$.unsubscribe();
    }


    private _onPackageUpdate() {
        this.packageUpdatetSubscription$ = this._webshopService.packageUpdate$
            .subscribe((axillaPackage: AxillaPackage) => {
                this.package = axillaPackage;
            });
    }
}
